import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftSideComponent } from './left-side/left-side.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PublicShellComponent } from './public-shell.component';
import { ComponentsModule } from '@shared/components/components.module';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, ComponentsModule],
  declarations: [LeftSideComponent, PublicShellComponent]
})
export class PublicShellModule {}
